module.exports = __webpack_public_path__ + "img/logo_biglobe_biz.a49893b7.png";